import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { DeviceFormComponent as EpDeviceFormComponent } from '@ep/shared';
import { DeviceFormService } from '@app/areas/merchants/services/device-form.service';

@Component({
  selector: 'app-device-form',
  templateUrl: './device-form.component.html',
  standalone: true,
  imports: [EpDeviceFormComponent, AsyncPipe],
})
export class DeviceFormComponent {
  private readonly deviceFormService = inject(DeviceFormService);

  protected deviceForm = this.deviceFormService.getForm();
  protected mode$ = this.deviceFormService.mode$;
}
